import { AnyAction } from 'redux';
import actionTypes from '../types/outPatientTypes';

const initialState = {
  frontDeskSearch: '',
  frontDeskData: {},
};

const reducer = (
  state: any = initialState,
  action: AnyAction,
): any => {
  switch (action.type) {
    case actionTypes.OUTPATIENT_FILTER_SEARCH:
      return {
        ...state,
        frontDeskSearch: action.payload,
      };
    case actionTypes.FRONTDESK_DATA:
      return {
        ...state,
        frontDeskData: action.payload,
      };
    default: return state;
  }
};

export { reducer as outPatientReducer };
